/**
 * MissionStatusBadge - Color-coded status badge for missions
 */
import React from 'react';

const STATUS_CONFIG = {
  draft: { label: 'Brouillon', classes: 'bg-gray-100 text-gray-700' },
  assigned: { label: 'Assignée', classes: 'bg-yellow-100 text-yellow-800' },
  accepted: { label: 'Acceptée', classes: 'bg-blue-100 text-blue-800' },
  in_progress: { label: 'En cours', classes: 'bg-indigo-100 text-indigo-800' },
  completed: { label: 'Terminée', classes: 'bg-green-100 text-green-800' },
  cancelled: { label: 'Annulée', classes: 'bg-red-100 text-red-800' },
};

export default function MissionStatusBadge({ status, size = 'sm' }) {
  const config = STATUS_CONFIG[status] || { label: status, classes: 'bg-gray-100 text-gray-600' };

  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full font-medium ${config.classes} ${
      size === 'xs' ? 'text-xs' : 'text-xs'
    }`}>
      {config.label}
    </span>
  );
}
